import React, { useState, useEffect } from 'react';
import { useAuthHeader, useAuthUser } from 'react-auth-kit';
import axios from 'axios';
import { Table, Badge, Button, Accordion, Card, Pagination, Row, Col } from 'react-bootstrap';
import AddRoutes from './PopUps/AddRoutes';
import EditRoutes from './PopUps/EditRoutes';
import * as Icon from 'react-feather';
import { canPageAction } from '../../config/roleConfig';
import DeactivateConfirmModal from '../Common/DeactivateConfirmModal';

function NewRoutes(props)  {
    const authHeader = useAuthHeader();
    const authUser = useAuthUser();

    const [data, setData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);
    const [expandedRoute, setExpandedRoute] = useState(null);
    const [routeToDeactivate, setRouteToDeactivate] = useState(null);
    const [deactivatingRoute, setDeactivatingRoute] = useState(false);
    const apiUrl = process.env.REACT_APP_URL;

    // Get current user info for client filtering
    const user = authUser();
    const userClientId = user?.client_id;
    const isClientUser = user?.roles?.some(role => role.title === 'Cliente');
    const canRead = canPageAction(user, 'operations.routes', 'read');
    const canWrite = canPageAction(user, 'operations.routes', 'write');
    const canDelete = canPageAction(user, 'operations.routes', 'delete');

    const get_all_routes = () => {
        axios({
            method:'GET',
            url:apiUrl+'/finance/get_all_routes',
            headers: {
                Authorization: authHeader()
            },
        }).then(response => {
            let routes = response.data.msg.Routes;

            // If user is a Client user, filter routes to only show their assigned client's routes
            if (isClientUser && userClientId) {
                routes = routes.filter(route => route.client_id === userClientId);
            }

            setData(routes);
        })
        .catch(error => {
            alert(error);
            console.log(error);
        });
    }

    useEffect(() => {
        get_all_routes();
    }, []);

    // Pagination logic
    const indexOfLastRoute = currentPage * itemsPerPage;
    const indexOfFirstRoute = indexOfLastRoute - itemsPerPage;
    const currentRoutes = data.slice(indexOfFirstRoute, indexOfLastRoute);
    const totalPages = Math.ceil(data.length / itemsPerPage);

    const toggleRouteDetails = (routeId) => {
        setExpandedRoute(expandedRoute === routeId ? null : routeId);
    };

    const deleteRoute = (route) => {
        if (!route) {
            return;
        }

        setDeactivatingRoute(true);
        axios({
            method: 'DELETE',
            url: apiUrl + '/finance/delete',
            headers: {
                Authorization: authHeader()
            },
            data: { id: route.id }
        }).then(() => {
            setRouteToDeactivate(null);
            refreshData();
        }).catch(error => {
            alert(error.response?.data?.error || 'No se pudo desactivar la ruta');
            console.log(error);
        }).finally(() => {
            setDeactivatingRoute(false);
        });
    };

    const getTypeBadge = (isLocal) => {
        if (isLocal) {
            return <Badge bg="info">Local</Badge>;
        }
        return <Badge bg="primary">Foráneo</Badge>;
    };

    const refreshData = () => {
        get_all_routes();
    };

    return (
        <>
        <div className="card mb-4">
            <div className="card-body">
                <div className="card-header d-flex justify-content-between">
                    <h5 className="card-title">Rutas</h5>
                    {canWrite && <AddRoutes setData={refreshData}/>}
                </div>

                <div>
                    <Table className="m-0" responsive>
                        <thead>
                            <tr>
                                <th>Cliente</th>
                                <th>Ruta</th>
                                <th>Precio</th>
                                <th>Tipo</th>
                                <th>No. Paradas</th>
                                <th>Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentRoutes.map(route => (
                                <React.Fragment key={route.id}>
                                    <tr>
                                        <td>{route.company_name}</td>
                                        <td>{route.name}</td>
                                        <td>${route.price}</td>
                                        <td>{getTypeBadge(route.is_local)}</td>
                                        <td>
                                            <Badge bg="secondary">{route.routeStops?.length || 0}</Badge>
                                        </td>
                                        <td>
                                            <div className="d-flex gap-1">
                                                {canRead && (
                                                    <Button
                                                        size="sm"
                                                        variant="outline-primary"
                                                        onClick={() => toggleRouteDetails(route.id)}
                                                    >
                                                        <Icon.Eye size={14} />
                                                    </Button>
                                                )}
                                                {canWrite && (
                                                    <EditRoutes
                                                        setData={refreshData}
                                                        routeInfo={route}
                                                    />
                                                )}
                                                {canDelete && (
                                                    <Button
                                                        size="sm"
                                                        variant="outline-danger"
                                                        onClick={() => setRouteToDeactivate(route)}
                                                    >
                                                        <Icon.Trash2 size={14} />
                                                    </Button>
                                                )}
                                                {!canRead && !canWrite && !canDelete && (
                                                    <span className="text-muted">N/A</span>
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                    {expandedRoute === route.id && (
                                        <tr>
                                            <td colSpan="6">
                                                <div className="p-3 bg-light">
                                                    <h6>Detalles de la Ruta</h6>
                                                    <div className="row mb-3">
                                                        <div className="col-md-4">
                                                            <p><strong>ID de Ruta:</strong> {route.id}</p>
                                                            <p><strong>Nombre:</strong> {route.name}</p>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <p><strong>Cliente:</strong> {route.company_name}</p>
                                                            <p><strong>Precio:</strong> ${route.price}</p>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <p><strong>Tipo:</strong> {route.is_local ? 'Local' : 'Foráneo'}</p>
                                                            <p><strong>Paradas:</strong> {route.routeStops?.length || 0}</p>
                                                        </div>
                                                    </div>

                                                    <h6>Paradas de la Ruta</h6>
                                                    <Accordion>
                                                        {route.routeStops?.map((stop, stopIndex) => (
                                                            <Accordion.Item
                                                                eventKey={stopIndex.toString()}
                                                                key={`${route.id}-stop-${stopIndex}`}
                                                            >
                                                                <Accordion.Header>
                                                                    <div className="d-flex justify-content-between w-100 me-3">
                                                                        <span>Parada {stopIndex + 1}: {stop.origin_address} → {stop.destination_address}</span>
                                                                    </div>
                                                                </Accordion.Header>
                                                                <Accordion.Body>
                                                                    <div className="mb-4">
                                                                        <Card className="border-0 bg-light">
                                                                            <Card.Body className="py-3">
                                                                                <Row className="align-items-center">
                                                                                    <Col md={5} className="text-center">
                                                                                        <div className="mb-2">
                                                                                            <h6 className="mb-1 text-primary">
                                                                                                <Icon.MapPin size={16} className="me-1" />
                                                                                                Origen
                                                                                            </h6>
                                                                                        </div>
                                                                                        <div className="fw-semibold" style={{ fontSize: '0.9rem' }}>
                                                                                            {stop.origin_address}
                                                                                        </div>
                                                                                    </Col>

                                                                                    <Col md={2} className="text-center">
                                                                                        <div className="d-flex align-items-center justify-content-center">
                                                                                            <div className="border-top border-2 border-primary flex-grow-1"></div>
                                                                                            <div className="mx-2">
                                                                                                <Icon.Truck size={24} className="text-primary" />
                                                                                            </div>
                                                                                            <div className="border-top border-2 border-primary flex-grow-1"></div>
                                                                                        </div>
                                                                                    </Col>

                                                                                    <Col md={5} className="text-center">
                                                                                        <div className="mb-2">
                                                                                            <h6 className="mb-1 text-success">
                                                                                                <Icon.Flag size={16} className="me-1" />
                                                                                                Destino
                                                                                            </h6>
                                                                                        </div>
                                                                                        <div className="fw-semibold" style={{ fontSize: '0.9rem' }}>
                                                                                            {stop.destination_address}
                                                                                        </div>
                                                                                    </Col>
                                                                                </Row>
                                                                            </Card.Body>
                                                                        </Card>
                                                                    </div>
                                                                </Accordion.Body>
                                                            </Accordion.Item>
                                                        ))}
                                                    </Accordion>

                                                    {(!route.routeStops || route.routeStops.length === 0) && (
                                                        <div className="text-center text-muted py-3">
                                                            <Icon.MapPin size={24} className="mb-2" />
                                                            <p>No hay paradas registradas para esta ruta</p>
                                                        </div>
                                                    )}
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                                </React.Fragment>
                            ))}
                            {currentRoutes.length === 0 && (
                                <tr>
                                    <td colSpan="6" className="text-center text-muted">
                                        No hay rutas registradas
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </Table>

                    {/* Pagination */}
                    {totalPages > 1 && (
                        <div className="d-flex justify-content-center mt-3">
                            <Pagination>
                                <Pagination.First
                                    onClick={() => setCurrentPage(1)}
                                    disabled={currentPage === 1}
                                />
                                <Pagination.Prev
                                    onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                                    disabled={currentPage === 1}
                                />

                                {Array.from({ length: totalPages }, (_, index) => {
                                    const page = index + 1;
                                    if (
                                        page === 1 ||
                                        page === totalPages ||
                                        (page >= currentPage - 2 && page <= currentPage + 2)
                                    ) {
                                        return (
                                            <Pagination.Item
                                                key={page}
                                                active={page === currentPage}
                                                onClick={() => setCurrentPage(page)}
                                            >
                                                {page}
                                            </Pagination.Item>
                                        );
                                    } else if (
                                        page === currentPage - 3 ||
                                        page === currentPage + 3
                                    ) {
                                        return <Pagination.Ellipsis key={page} />;
                                    }
                                    return null;
                                })}

                                <Pagination.Next
                                    onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                                    disabled={currentPage === totalPages}
                                />
                                <Pagination.Last
                                    onClick={() => setCurrentPage(totalPages)}
                                    disabled={currentPage === totalPages}
                                />
                            </Pagination>
                        </div>
                    )}

                    <div className="mt-2 text-center text-muted">
                        Mostrando {indexOfFirstRoute + 1} a {Math.min(indexOfLastRoute, data.length)} de {data.length} rutas
                    </div>
                </div>
            </div>
        </div>
        <DeactivateConfirmModal
            show={Boolean(routeToDeactivate)}
            title="Desactivar Ruta"
            itemLabel={routeToDeactivate?.name}
            confirming={deactivatingRoute}
            onCancel={() => !deactivatingRoute && setRouteToDeactivate(null)}
            onConfirm={() => deleteRoute(routeToDeactivate)}
        />
        </>
    );

}

//Status: Entregado, Pendiente, Cancelado, En camino
// Success, Warning, Danger, Info
//https://react-bootstrap.netlify.app/docs/components/badge/
export default NewRoutes;
